/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import { REPORT_CODES } from '@/constants/reportCodes'
export default {
  fetchNeraca (context, payload) {
    const company = JSON.parse(localStorage.getItem('activeCompany') || '{}')
    return new Promise((resolve, reject) => {
      axios.get(`/report/${company.id}/financial-statement/${REPORT_CODES.BALANCE_SHEET}/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchLabaRugi (context, payload) {
    const company = JSON.parse(localStorage.getItem('activeCompany') || '{}')
    return new Promise((resolve, reject) => {
      axios.get(`/report/${company.id}/income-statement/${REPORT_CODES.INCOME_STATEMENT}/${payload.startDate}/${payload.endDate}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  printReportNeraca (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/${payload.company_id}/financial-statement/${REPORT_CODES.BALANCE_SHEET}/print/${payload.start_date}/${payload.end_date}`, {
        responseType: 'blob' // penting untuk file PDF
      })
        .then((response) => {
        // Buat URL untuk download file
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'financial-statement.pdf')
          document.body.appendChild(link)
          link.click()

          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  printReportLabaRugi (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/${payload.company_id}/income-statement/${REPORT_CODES.INCOME_STATEMENT}/print/${payload.start_date}/${payload.end_date}`,
        {},
        {
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
          }
        }
      )
        .then((response) => {
          // Create blob URL for download
          const blob = new Blob([response.data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)

          // Create download link
          const link = document.createElement('a')
          link.href = url

          // Generate filename with timestamp
          const timestamp = new Date().toISOString().slice(0, 10).replace(/-/g, '')
          link.setAttribute('download', `laporan-laba-rugi-${timestamp}.pdf`)

          // Append to body and trigger download
          document.body.appendChild(link)
          link.click()

          // Cleanup
          setTimeout(() => {
            window.URL.revokeObjectURL(url)
            document.body.removeChild(link)
          }, 100)

          resolve({
            success: true,
            message: 'Laporan berhasil diunduh',
            blob: response.data
          })
        })
        .catch((error) => {
          // Handle blob error response
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result)
                reject({
                  success: false,
                  message: errorData.message || 'Gagal menghasilkan laporan',
                  error: errorData
                })
              } catch (e) {
                reject({
                  success: false,
                  message: 'Terjadi kesalahan pada server'
                })
              }
            }
            reader.readAsText(error.response.data)
          } else if (error.response && error.response.data) {
            reject({
              success: false,
              message: error.response.data.message || 'Gagal memproses permintaan',
              error: error.response.data
            })
          } else if (error.request) {
            reject({
              success: false,
              message: 'Tidak ada respon dari server'
            })
          } else {
            reject({
              success: false,
              message: error.message || 'Terjadi kesalahan'
            })
          }
        })
    })
  }
}
